import { useMemo } from "react";
import { apiBaseScope } from "../../config";

export function useApiScope(scopePath = "") {
  return useMemo(() => new URL(scopePath, apiBaseScope).href, [scopePath]);
}